import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "../../../order.service";
import { SaleMethodBranchModel, SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { takeUntil } from "rxjs/operators";
import { SalonOrderService } from "../../../salonorder/salonorder.service";
import { CustomerOrderService } from "../../../customerorder/customerorder.service";
import { ActivePageEnum } from "../../../model/activepage.enum";
import { ItemOrderService } from "../../item/itemorder.service";
import { InvoiceStatus } from "../../../model/invoice.model";
import { Permission } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { AppInjector } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";

@Component({
  selector: "order-invoicechangefastaccess",
  templateUrl: "./invoicechangefastaccess.component.html",
  styleUrls: ["./invoicechangefastaccess.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceChangeFastAccess extends BaseListComponent {
  @Input() currentSaleMethodBranch: SaleMethodBranchModel;
  itemDependentQty: number;
  constructor(
    public order: OrderService,
    private itemOrder: ItemOrderService,
    __id: FormContainerModel,
    public salonService: SalonOrderService,
    public cd: ChangeDetectorRef,
    public customer: CustomerOrderService,
    public _httpCommonService: HttpCommonService
  ) {
    super();
    this.currentTabId = __id.metadata.id;
    this.order.cd_FastAccessInvoiceChange = cd;
    this._httpCommonService = AppInjector.get(HttpCommonService);
  }
  ngOnInit() {
    this.getSaleMethod();
    this.areaName = "RestaurantSale";
  }
  getSaleMethod() {
    if (this.order.saleMethodList && this.order.saleMethodList.length > 0) {
      this.order.currentsaleMethodList = this.order.saleMethodList.filter(
        (f) => f.Id !== this.order.saleMethodBranch.Id && f.BranchId === this.order.accountService.authService?.currentBranchId && !!f.IsActive
      );
      return;
    }
    this.httpCommonService
      .getList("Invoice/GetSaleMethodBranch")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: SaleMethodBranchModel[]) => {
        this.order.saleMethodList = data;
        this.order.currentsaleMethodList = this.order.saleMethodList.filter(
          (f) => f.Id !== this.order.saleMethodBranch.Id && f.BranchId === this.order.accountService.authService?.currentBranchId && !!f.IsActive
        );
        this.order.detectChanges();
      });
  }
  async changeSaleMethod(SaleMethodBranch: SaleMethodBranchModel) {
    if (
      (this.order.saleMethodBranch.SaleMethod.SaleMethodNatureCode === SaleMethodNature.Restaurant ||
        this.order.saleMethodBranch.SaleMethod.SaleMethodNatureCode === SaleMethodNature.FastFood) &&
      SaleMethodBranch.SaleMethodNatureCode == SaleMethodNature.Delivery &&
      !SaleMethodBranch.HasDeposit
    )
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.TransferredToPaidSubscribers")}`,
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.ChangingWayOfSelling"),
        DialogType.confirm,
        () => {
          for (let i = 0; i < this.order.invoice.ReceiptPayments.length; i++) {
            this.order.invoice.ReceiptPayments[i].State = RowState.Delete;
          }
          this.order.getSaleMethodType();
          this.order.invoice.State = RowState.Modify;
          this.setChangeSaleMethod(SaleMethodBranch);
        }
      );
    else if (
      this.order.saleMethodBranch.SaleMethod.SaleMethodNatureCode === SaleMethodNature.Delivery &&
      this.order.invoice?.StatusCode == InvoiceStatus.Assigned
    ) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.RemoveInvoiceFromCourierName"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.Warning")
      );
      return;
    } else this.setChangeSaleMethod(SaleMethodBranch);
  }
  setChangeSaleMethod(SaleMethodBranch: SaleMethodBranchModel) {
    const hasAccess = this.accountService.userHasPermission(`RestaurantSale:Invoice_${SaleMethodBranch.SaleMethodId}`, Permission.viewPermission);
    if (!hasAccess) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.ErrorMessage"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.AccessToThisArea")
      );
      return;
    }
    this.setStateOfInvoice(SaleMethodBranch);
    if (this.order.oldSaleMethodBranchId !== SaleMethodBranch.Id) {
      /// تعویض از رستورانی به باقی نحوه های فروش
      if (SaleMethodBranch.SaleMethodNatureCode === SaleMethodNature.Restaurant) {
        this.order.saleMethodBranchChanged = true;
        this.salonService.tableFilter.forEach((element) => {
          if (element.key === 1) element.selected = true;
          else element.selected = false;
        });
      } else this.order.saleMethodBranchChanged = false;
    }
    this.order.currentsaleMethodList = this.order.saleMethodList.filter(
      (f) => f.Id !== this.order.saleMethodBranch.Id && f.BranchId === this.order.accountService.authService?.currentBranchId && !!f.IsActive
    );
    this.order.invoiceChanged = true;
    if (!SaleMethodBranch.TableIsRequired && this.order.invoice.TableId) this.order.invoice.TableId = null;
    this.order.saleMethodBranch = JSON.parse(JSON.stringify(SaleMethodBranch));
    this.order.invoice.Discount = SaleMethodBranch.Discount ? SaleMethodBranch.Discount : 0;
    this.order.setInvoiceHasFactorAndHasPaymentLink();
    this.order.currentSaleMethodNature = SaleMethodBranch.SaleMethodNatureCode;
    this.order.invoice.SaleMethodBranch = this.order.saleMethodBranch;
    this.order.invoice.OldSaleMethodBranchId = this.order.oldSaleMethodBranchId;
    this.order.invoice.SaleMethodBranchId = this.order.saleMethodBranch.Id;
    this.itemDependentQty = this.order?.selectedOrderItem?.InvoiceQty;
    if (SaleMethodBranch.SaleMethod.SaleMethodNatureCode === SaleMethodNature.Restaurant && this.order.currentActivePage === ActivePageEnum.Salon)
      this.salonService.getSalon();
    this.order.getSaleMethodType();

    /// حذف ایتم های وابسته درصورت نداشتن در نحوه فروش
    // if (SaleMethodBranch.SaleMethod.SaleMethodNatureCode === SaleMethodNature.Delivery)
    //   this.customer.setCostomerInfo(null, this.order.customer);
    this.itemOrder.hasDependents(this.order.selectedOrderItem, this.itemDependentQty);
    this.order.hasDependents();
    this.order.formGroupControl();
    this.order.setValueformGroupControl();
    this.order.calculate();
    this.order.setValueQuantity();
    this.order.detectChanges();

    this.order.checkInvoiceState(this.order.invoice.CommandCode);
    this.sts.showToast(
      "success",
      this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.Attention"),
      `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.SalesInvoiceAccording")} ${
        SaleMethodBranch.SaleMethodNatureTitle
      } ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.Transferred")}`
    );
    this.order.closeSidebar();
    this.sts.showToast(
      "success",
      this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.Attention"),
      `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.SalesInvoiceAccording")} ${
        SaleMethodBranch.SaleMethodNatureTitle
      } ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.Transferred")}`
    );
  }

  setStateOfInvoice(SaleMethodBranch: SaleMethodBranchModel) {
    const currentSaleMethodNatureCode = this.order.saleMethodBranch?.SaleMethodNatureCode,
      newSaleMethodNatureCode = SaleMethodBranch.SaleMethodNatureCode,
      currentStatusCode = this.order.invoice?.StatusCode;

    switch (currentSaleMethodNatureCode) {
      case SaleMethodNature.Restaurant:
        switch (newSaleMethodNatureCode) {
          case SaleMethodNature.FastFood:
            if (
              currentStatusCode === InvoiceStatus.Pending ||
              currentStatusCode === InvoiceStatus.Ordering ||
              currentStatusCode === InvoiceStatus.Clearing
            ) {
              this.order.invoice.StatusCode = InvoiceStatus.Pending;
            } else if (currentStatusCode === InvoiceStatus.Cleared) {
              this.order.invoice.StatusCode = InvoiceStatus.Cleared;
            }
            break;
          case SaleMethodNature.Delivery:
            if (currentStatusCode === InvoiceStatus.Pending) {
              this.order.invoice.StatusCode = InvoiceStatus.Pending;
            } else if (
              currentStatusCode === InvoiceStatus.Cleared ||
              currentStatusCode === InvoiceStatus.Ordering ||
              currentStatusCode === InvoiceStatus.Clearing
            ) {
              this.order.invoice.StatusCode = InvoiceStatus.Ordering;
            }
            break;
        }
        break;
      case SaleMethodNature.FastFood:
        switch (newSaleMethodNatureCode) {
          case SaleMethodNature.Restaurant:
            if (currentStatusCode === InvoiceStatus.Pending) {
              this.order.invoice.StatusCode = InvoiceStatus.Pending;
            } else if (currentStatusCode === InvoiceStatus.Cleared) {
              this.order.invoice.StatusCode = InvoiceStatus.Cleared;
            }
            break;
          case SaleMethodNature.Delivery:
            if (currentStatusCode === InvoiceStatus.Pending) {
              this.order.invoice.StatusCode = InvoiceStatus.Pending;
            } else if (currentStatusCode === InvoiceStatus.Cleared) {
              this.order.invoice.StatusCode = InvoiceStatus.Ordering;
            }
            break;
        }

        break;
      case SaleMethodNature.Delivery:
        switch (newSaleMethodNatureCode) {
          case SaleMethodNature.FastFood:
            if (currentStatusCode === InvoiceStatus.Pending) {
              this.order.invoice.StatusCode = InvoiceStatus.Pending;
            } else if (currentStatusCode === InvoiceStatus.Ordering) {
              this.order.invoice.StatusCode = InvoiceStatus.Pending;
            }
            break;
          case SaleMethodNature.Restaurant:
            if (currentStatusCode === InvoiceStatus.Pending) {
              this.order.invoice.StatusCode = InvoiceStatus.Pending;
            } else if (currentStatusCode === InvoiceStatus.Ordering) {
              this.order.invoice.StatusCode = InvoiceStatus.Ordering;
            }
            break;
        }
        break;
    }
  }
}
